<p
  class="error-msg stacked-item"
  translate="error-renderer-missing-parameters-main-message"
  [translateParams]="translationParams">
</p>

<button
  class="tertiary-btn stacked-item"
  (click)="toggleErrors()">
  {{ (showErrors ? 'error-renderer-missing-parameters-hide-details' : 'error-renderer-missing-parameters-show-details') | translate }}
</button>

@if (showErrors) {
  <p
    class="error-msg stacked-item"
    translate="error-renderer-missing-parameters-stacked-message">
  </p>
}

@if (showErrors) {
  @for (error of errors | keyvalue; track error) {
    <p class="error-msg stacked-item">
      [{{error.value}}]
    </p>
  }
}

@if (setupInstructionsLink && showErrors) {
  <a
    href="{{setupInstructionsLink}}"
    target="_blank"
    class="primary-btn stacked-item"
    translate="error-renderer-view-setup-instructions">
  </a>
}

<a
  href="{{contactSupport}}"
  target="_blank"
  class="tertiary-btn stacked-item"
  translate="error-renderer-contact-support">
</a>
